<template>
  <div class="prose">
    <slot></slot>
  </div>
</template>
<script>
export default {
  name: 'TextProse'
}
</script>


<style lang="postcss">
.prose {
  @apply text-lg mb-16;
}

.prose h1:not(.unprose) {
  @apply text-secondary text-3xl font-semibold mb-4;
}

.prose h2:not(.unprose) {
  @apply text-secondary text-xl font-semibold mb-4;
}

.prose h3:not(.unprose) {
  @apply text-secondary text-lg font-semibold mb-4;
}

.prose h4:not(.unprose) {
  @apply text-secondary text-lg font-semibold mb-4;
}

.prose h5:not(.unprose),
.prose h6:not(.unprose) {
}

.prose ul:not(.unprose) {
  @apply pl-8;
  margin-bottom: 2em;
}
.prose li:not(.unprose) {
  @apply text-lg mb-2 list-disc;
}
.prose p:not(.unprose) {
  margin-bottom: 2em;
}
.prose p:not(.unprose) iframe {
  @apply w-full;
}
.prose strong:not(.unprose) {
  @apply font-semibold;
}

.prose small:not(.unprose) {
}

.prose a:not(.unprose) {
  @apply no-underline font-semibold text-secondary;
}

.prose a:not(.unprose):hover {
  @apply text-primary;
}

.prose img:not(.unprose),
.prose video:not(.unprose) {
  @apply mb-6;
}

.prose h1:first-child:not(.unprose),
.prose h2:first-child:not(.unprose),
.prose h3:first-child:not(.unprose),
.prose h4:first-child:not(.unprose),
.prose h5:first-child:not(.unprose),
.prose h6:first-child:not(.unprose) {
  @apply pt-0;
}

.prose > p:first-child:not(.unprose) {
  @apply text-xl font-semibold;
}

.prose blockquote:not(.unprose) {
  @apply my-12 border-l-4 px-6;
  border-color: rgba(0, 137, 63, 0.2);
}

.prose blockquote *:not(.unprose),
.prose blockquote *:first-child:not(.unprose) {
  @apply text-secondary text-3xl font-semibold;
}

.table-mobile {
  @apply overflow-x-scroll scrolling-touch;
  margin-bottom: 2em;
}

.prose table {
  @apply w-full text-left text-primary  border-primary border-t-4 border-collapse;
}

.prose th {
  @apply bg-primary-lighter font-semibold;
}

.prose tr {
  @apply border border-white;
}

.prose th,
.prose td {
  @apply p-4;
}

.prose td {
  @apply bg-primary-lightest;
}

/* Clear bottom margins if element is last in container */
.prose *:last-child:not(.unprose) {
  @apply mb-0;
}
/* end prose-specific rules */
</style>
